export const raise = (message: string) => {
	throw new Error(message);
}
